import { render, staticRenderFns } from "./jgpublicityQuery.vue?vue&type=template&id=25c5b4d0&scoped=true"
import script from "./jgpublicityQuery.vue?vue&type=script&lang=js"
export * from "./jgpublicityQuery.vue?vue&type=script&lang=js"
import style0 from "./jgpublicityQuery.vue?vue&type=style&index=0&id=25c5b4d0&prod&lang=less&scoped=true"
import style1 from "./jgpublicityQuery.vue?vue&type=style&index=1&id=25c5b4d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c5b4d0",
  null
  
)

export default component.exports